<template>
	<component :is="tag" :class="cls" class="api-error">
		<sym-icon v-if="icon" :name="icon"></sym-icon>
		<div v-if="html" class="readable" v-html="message"></div>
		<div v-else class="readable">{{ message }}</div>
		<it-link v-for="a in actions" class="fi-action input-height" :class="a.class" :to="a.link">{{ a.label }}</it-link>
	</component>
</template>

<script setup lang="ts">
import {computed} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {ApiErrorAction, ErrorLevel} from "@t/util/ApiError.ts";
import ItLink from "@/router/ItLink.vue";

const props = withDefaults(defineProps<{
	level: ErrorLevel,
	message: string,
	icon?: string,
	tag?: string,
	html?: boolean,
	color?: number,
	actions?: ApiErrorAction[]
}>(), { tag: "div", actions: () => [], html:false });

const cls = computed(() => {
   const c:string[] = ["fd-message"];
   if ("SEVERE" === props.level) c.push("fd-error");
   else if ("WARNING" === props.level) c.push("fd-warning");
   else if ("NOTE" === props.level) c.push("fd-note");
   else c.push("fd-info");
   if (props.color>0) c.push("fd-color-"+props.color);
   return c;
});

//console.log("props:"+JSON.stringify(props));
</script>

<style>
.api-error {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	column-gap: 4px;
}

.api-error p {
	line-height: 1.5;
    margin-block-start: 0;
    margin-block-end: 0;
}

.fd-message {
	border-left: 1px solid var(--fg);
	background-color: var(--bg);
	color: var(--fg);
	padding: 2px 5px;
	font-size: var(--font-size-s);

	& .fi {
		font-size: var(--font-size);
	}
}
.fd-message.no-border {
	border-left: none;
}
.form-error-body {
	/* This is a global error and should use bigger font */
	& > .fd-message {
		font-size: var(--font-size);
		padding-block: 5px;
	}
}
.fd-error {
	--border-color: var(--error-fg);
	--fg: var(--error-fg);
	--bg: var(--error-bg);
}
.fd-warning {
	--border-color: var(--warn-fg);
	--fg: var(--warn-fg);
	--bg: var(--warn-bg);
	position: relative;

	&::before {
		content: '';
		background-color: var(--fg);
		width: 4px;
		top: 2px;
		bottom: 2px;
		position: absolute;
		left: 2px;
		border-radius: 2px;
		opacity: 0.5;
	}
}
.fd-info {
	--border-color: var(--info-fg);
	--fg: var(--info-fg);
	--bg: var(--info-bg);
}
.fd-note {
	--border-color: var(--note-fg);
	--fg: var(--notify-fg);
	--bg: var(--notify-bg);
	position: relative;

	&::before {
		content: '';
		background-color: var(--fg);
		width: 4px;
		top: 2px;
		bottom: 2px;
		position: absolute;
		left: 2px;
		border-radius: 2px;
		opacity: 0.5;
	}
}

	.fd-color-1 {
		--bg: var(--notify-bg-1);
		--fg: var(--notify-fg-1);
	}

	.fd-color-2 {
		--bg: var(--notify-bg-2);
		--fg: var(--notify-fg-2);
	}

	.fd-color-3 {
		--bg: var(--notify-bg-3);
		--fg: var(--notify-fg-3);
	}

	.fd-color-4 {
		--bg: var(--notify-bg-4);
		--fg: var(--notify-fg-4);
	}

	.fd-color-5 {
		--bg: var(--notify-bg-5);
		--fg: var(--notify-fg-5);
	}

	.fd-color-6 {
		--bg: var(--notify-bg-6);
		--fg: var(--notify-fg-6);
	}

	.fd-color-7 {
		--bg: var(--notify-bg-7);
		--fg: var(--notify-fg-7);
	}

	.fd-color-8 {
		--bg: var(--notify-bg-8);
		--fg: var(--notify-fg-8);
	}

	.fd-color-9 {
		--bg: var(--notify-bg-9);
		--fg: var(--notify-fg-9);
	}

	.fd-color-10 {
		--bg: var(--notify-bg-10);
		--fg: var(--notify-fg-10);
	}

	.fd-color-11 {
		--bg: var(--notify-bg-11);
		--fg: var(--notify-fg-11);
	}

	.fd-color-12 {
		--bg: var(--notify-bg-12);
		--fg: var(--notify-fg-12);
	}
</style>